const InstallationStatus = {
    initiated: 1,
    inprogress: 2,
    inactive: 3,
    completed: 4,
} as const;

const UpdatedBy = {
    customer: 1,
    installer: 2,
    admin: 3,
} as const;

type InstallationStatusType = (typeof InstallationStatus)[keyof typeof InstallationStatus];
type UpdatedByType = (typeof UpdatedBy)[keyof typeof UpdatedBy];

export { InstallationStatus, UpdatedBy, InstallationStatusType, UpdatedByType };
